import { nanoid } from 'nanoid';
import fetch from 'node-fetch';
import emptyStringToUndefined from '../emptyStringToUndefined';
import { ComponentError, JoiErrorResponse } from '../../types/misc';
import { Domain } from '../../types/distribution';

interface UpdateDomainResponse {
    success: boolean,
    domain?: Domain,
    errors: ComponentError[]
}

const updateDomain = async (token: string, distributionName: string, domain: Domain): Promise<UpdateDomainResponse> => {
    const response = await fetch(`${process.env.REACT_APP_ADN_MANAGEMENT_BASE_URL}/v1/distributions/${distributionName}/domains/${domain.id}`, {
        method: 'PUT',
        headers: {
            Authorization: `Bearer ${token}`,
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(emptyStringToUndefined(
            {
                ...domain,
                id: undefined // the API does not allow ID in the API request
            }
        ))
    });

    if (response.status === 400) {
        const error = (await response.json()) as JoiErrorResponse;

        // not a joi error
        if (!error.validation) {
            return {
                success: false,
                errors: [{
                    message: error.message,
                    path: '',
                    uiId: nanoid()
                }]
            };
        }

        return {
            success: false,
            errors: error.validation.errors
        };
    }

    if (!response.ok) {
        throw new Error(`Unexpected error when updating domain. Got status code ${response.status}`);
    }

    return {
        success: true,
        domain: await response.json(),
        errors: []
    };
};

export default updateDomain;
